// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import serverPath from './assets/js/serverPath.js'
import axios from 'axios'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import echarts from 'echarts'
import store from './store'
import settings from './assets/js/settings.js'
import request from './assets/js/request.js'
import VueRouter from 'vue-router'
import VueDND from 'awe-dnd'
import Fragment from 'vue-fragment'
import VCharts from 'v-charts-v2'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import foxPreviewImage from 'fox-preview-image'
import VueIntro from 'vue-introjs'
import 'intro.js/introjs.css'
import Sortable from 'sortablejs'

Vue.use(VueIntro)
Vue.use(Viewer)
Viewer.setDefaults({
	Options: {
		'inline': true,
		'button': true,
		'navbar': true,
		'title': true,
		'toolbar': true,
		'tooltip': true,
		'movable': true,
		'zoomable': true,
		'rotatable': true,
		'scalable': true,
		'transition': true,
		'fullscreen': true,
		'keyboard': true,
		'url': 'data-source'
	}
})
Vue.use(foxPreviewImage)
Vue.use(Fragment.Plugin)

Vue.use(VueDND)
Vue.use(ElementUI)
Vue.use(VCharts)
Vue.config.productionTip = false
Vue.prototype.$http = axios
Vue.prototype.$echarts = echarts
Vue.prototype.settings = settings
Vue.prototype.request = request
Vue.prototype.Sortable = Sortable
Vue.config.productionTip = true
// 设置全局请求前缀
axios.defaults.baseURL = serverPath.serverPath

axios.interceptors.request.use(function (config) {
	if (config.url != 'api/v1/login') {
		var token = window.localStorage.getItem('LTokenD')
		if (!token || token == '') {
			router.replace({
				path: '/'
			})
		} else {
			// 设置全局请求头部信息
			config.headers.common['token'] = token
		}
	}
	return config
}, function (error) {
	return Promise.reject(error)
})
// 拦截器
// 添加响应拦截器
axios.interceptors.response.use(function (response) {
	// 对响应数据做点什么
	if (response.data.status === 10001) {
		localStorage.removeItem('LTokenD')
		router.replace('/')
	}
	return response
}, function (error) {
	// 对响应错误做点什么
	return Promise.reject(error)
})
// 拦截器
router.beforeEach((to, from, next) => {
	if (to.path === '/') {
		next()
	} else {
		let token = window.localStorage.getItem('LTokenD')
		if (token === null || token === '' || token === undefined) {
			next('/')
		} else {
			next()
		}
	}
})

/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	store,
	components: {
		App
	},
	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js